"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Header4 = exports.Header2 = void 0;
var Header2_1 = require("./Header2");
Object.defineProperty(exports, "Header2", { enumerable: true, get: function () { return Header2_1.Header2; } });
var Header4_1 = require("./Header4");
Object.defineProperty(exports, "Header4", { enumerable: true, get: function () { return Header4_1.Header4; } });
var Text_1 = require("./Text");
Object.defineProperty(exports, "Text", { enumerable: true, get: function () { return Text_1.Text; } });
